export var LocaleCode;
(function (LocaleCode) {
    LocaleCode["en_US"] = "en-US";
    LocaleCode["en_CA"] = "en-CA";
    LocaleCode["en_GB"] = "en-GB";
    LocaleCode["fr_CA"] = "fr-CA";
})(LocaleCode || (LocaleCode = {}));
export var CountryCode;
(function (CountryCode) {
    CountryCode["US"] = "US";
    CountryCode["CA"] = "CA";
    CountryCode["GB"] = "GB";
})(CountryCode || (CountryCode = {}));
export var CountryName;
(function (CountryName) {
    CountryName["US"] = "United States";
    CountryName["CA"] = "Canada";
    CountryName["GB"] = "United Kingdom";
})(CountryName || (CountryName = {}));
//# sourceMappingURL=LocaleCode.js.map